import { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./authdatapage.css";

const STEPS = ["User Type Master"];

const USER_TYPES = [
  "Super User",
  "Doctor",
  "Hospital",
  "Patient",
  "HCF",
  "Service Provider",
];

const UserTypeMasterForm = () => (
  <>
    <Row className="mb-4">
      <Form.Group as={Col} md="6" controlId="userTypeId">
        <Form.Label>a. User Type ID</Form.Label>
        <Form.Control type="text" placeholder="Enter user type ID" required />
        <Form.Control.Feedback type="invalid">Required</Form.Control.Feedback>
      </Form.Group>
    </Row>
    <Row className="mb-4">
      <Form.Group as={Col} md="6" controlId="userType">
        <Form.Label>b. User Type</Form.Label>
        <Form.Select required>
          <option value="">Select user type</option>
          {USER_TYPES.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          Please select a user type.
        </Form.Control.Feedback>
      </Form.Group>
    </Row>
  </>
);

const STEP_FORMS = [UserTypeMasterForm];

const STEP_DESCRIPTIONS = [
  "Define the user type ID and assign a role for this account.",
];

export const AuthDataPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [validated, setValidated] = useState(false);

  const StepForm = STEP_FORMS[currentStep];
  const isLastStep = currentStep === STEPS.length - 1;

  const handleNext = (e) => {
    const form = e.currentTarget.closest("form");
    if (form.checkValidity() === false) {
      e.preventDefault();
      setValidated(true);
      return;
    }
    setValidated(false);
    setCurrentStep((s) => Math.min(s + 1, STEPS.length - 1));
  };

  const handlePrev = () => {
    setValidated(false);
    setCurrentStep((s) => Math.max(s - 1, 0));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    // TODO: submit logic
    alert("Profile submitted successfully!");
  };

  return (
    <section className="authdata-section">
      <Container fluid className="authdata-container">
        <Row className="authdata-row">
          {/* Left Column — Step Titles */}
          <Col md={3} lg={2} className="authdata-left">
            <div className="authdata-brand">List of menus</div>
            <ul className="authdata-steps">
              {STEPS.map((step, i) => (
                <li
                  key={step}
                  className={`authdata-step-item ${
                    i === currentStep
                      ? "active"
                      : i < currentStep
                      ? "completed"
                      : ""
                  }`}
                  onClick={() => i < currentStep && setCurrentStep(i)}
                >
                  <span className="step-indicator">
                    {i < currentStep ? "✓" : i + 1}
                  </span>
                  <span className="step-label">{step}</span>
                </li>
              ))}
            </ul>
            {/* <div className="authdata-progress">
              <div className="progress-bar-track">
                <div
                  className="progress-bar-fill"
                  style={{
                    height: `${((currentStep) / (STEPS.length - 1)) * 100}%`,
                  }}
                />
              </div>
            </div> */}
          </Col>

          {/* Right Column — Form */}
          <Col md={9} lg={10} className="authdata-right">
            <div className="authdata-form-wrapper">
              <div className="authdata-form-header">
                {/* <span className="step-badge">Step {currentStep + 1} of {STEPS.length}</span> */}
                <h3>{STEPS[currentStep]}</h3>
                <p>{STEP_DESCRIPTIONS[currentStep]}</p>
              </div>

              <Form noValidate validated={validated} onSubmit={handleSubmit} className="authdata-form">
                <div className="authdata-form-body">
                  <StepForm />
                </div>

                <div className="authdata-form-actions">
                  {/* <Button
                    variant="outline-secondary" 
                    onClick={handlePrev}
                    disabled={currentStep === 0}
                    className="btn-prev"
                  >
                    ← Previous
                  </Button> */}

                  {!isLastStep ? (
                    <Button
                      variant="primary"
                      className="btn-next"
                      onClick={handleNext}
                    >
                      Next →
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="success"
                      className="btn-submit"
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
